export const mood_status_style = {
    appBarSx:{
        bgcolor:"purple.A100",
        pb:2
    },
    childrenSx:{
        pb:0
    }
}